import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '/api',
    timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在请求发送之前做一些处理（例如添加 token 等）
        return config
    },
    error => {
        console.error('请求错误:', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        console.log('原始响应数据:', response)
        console.log('response.data:', response.data)
        
        const res = response.data
        
        // 如果响应数据本身就是数组，直接返回
        if (Array.isArray(res)) {
            console.log('直接返回数组')
            return res
        }
        
        // 如果有 code 字段，判断是否成功
        if (typeof res.code === 'number' && res.code !== 200 && res.code !== 0) {
            console.error('API 响应错误:', res.message || 'Error')
            return Promise.reject(new Error(res.message || 'Error'))
        }
        
        // 处理分页数据结构：{ code: 0, msg: "success", data: { list: [...], total: 3 } }
        if (res.data && typeof res.data === 'object') {
            // 如果有 data.list 结构，返回整个 data 对象
            if (res.data.list || res.data.records) {
                console.log('返回分页数据对象:', res.data)
                return res.data
            }
        }
        
        // 返回 data 字段（如果有）
        const result = res.data !== undefined ? res.data : res
        console.log('最终返回的数据:', result)
        return result
    },
    error => {
        console.error('HTTP 错误:', error)
        return Promise.reject(error)
    }
)

export default service
